import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'details-schedule',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './schedule.component.html',
  styleUrl: './schedule.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailsScheduleComponent {
  public translate = inject(TranslateService);
  public schedule: InputSignal<any[]> = input.required<any[]>();
  public fromBottomSheet: InputSignal<boolean> = input.required<boolean>();
}